import { useEffect, useState } from 'react';

// Thời lượng dạng HH:mm:ss giữa hai mốc thời gian.
export function formatElapsed(start?: string | Date, end?: string | Date): string {
  if (!start) return '00:00:00';
  const s = new Date(start).getTime();
  const e = end ? new Date(end).getTime() : Date.now();
  if (isNaN(s) || isNaN(e)) return '00:00:00';
  const total = Math.max(0, Math.floor((e - s) / 1000));
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(Math.floor(total / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
}

// Đồng hồ đếm giờ làm, cập nhật mỗi giây. Luôn suy ra từ mốc bắt đầu (không
// cộng dồn biến đếm) nên chuyển tab hoặc mất mạng vẫn hiển thị đúng.
export function useElapsed(start?: string | null): string {
  const [label, setLabel] = useState(() => formatElapsed(start ?? undefined));

  useEffect(() => {
    if (!start) {
      setLabel(formatElapsed(undefined));
      return;
    }
    setLabel(formatElapsed(start));
    const id = window.setInterval(() => setLabel(formatElapsed(start)), 1000);
    return () => window.clearInterval(id);
  }, [start]);

  return label;
}
